<!-- Page Sidebar Start-->
<div class="logo-wrapper">
  <a class="sidebar-brand" [attr.title]="sidebarIsCollapsed ? 'Fawtara' : null">
    <img
      class="sidebar-brand__mark"
      src="../../../../assets/images/logo/thi-cropped.png"
      alt="Fawtara"
    />
  </a>
  <button
    type="button"
    class="back-btn sidebar-toggle-btn"
    (click)="sidebarToggle()"
    [attr.title]="getToggleTooltip(sidebarIsCollapsed)"
    [attr.aria-label]="getToggleTooltip(sidebarIsCollapsed)"
    [attr.aria-expanded]="!sidebarIsCollapsed"
  >
    <i class="fa" [ngClass]="getToggleIconClass(sidebarIsCollapsed)"></i>
  </button>
</div>

<nav class="sidebar-main">
  <div class="left-arrow" id="left-arrow" [class.d-none]="leftArrowNone" (click)="scrollToLeft()">
    <app-feather-icons [icon]="'arrow-left'"></app-feather-icons>
  </div>

  <div id="sidebar-menu" [ngStyle]="{ marginLeft: this.layout.config.settings.layout == 'Rome' || 'Singapore' || 'Barcelona' ? margin + 'px' : '0px' }">
  <ul class="sidebar-links custom-scrollbar">
    <div class="simplebar-wrapper">
      <div class="simplebar-mask">
        <div class="simplebar-offset">
          <div class="simplebar-content-wrapper">
            <div class="simplebar-content">
              <li class="back-btn">
                <a href="javascript:void(0)">
                  <h3 style="color: #141414;">{{ curentLang === 'en' ? 'Fawtara' : (curentLang === 'ar' ? 'فوترة' : 'חיוב') }}</h3>
                </a>
                <div class="mobile-back text-end" (click)="sidebarToggle()">
                  <span> {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'عودة' : 'חזרה')}} </span>
                  <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
                </div>
              </li>

              <ng-container *ngFor="let item of sidebarItems">
                <li class="{{(currentHref == item.route) ? 'mm-active' : ''}}" *ngIf="!((userType || '').toLowerCase() === 'admin' && item.title === 'Users' )" >
                  <a
                    [routerLink]="item.routerLink ?? [item.route]"
                    [queryParams]="item.queryParams"
                    class="sidebar-link sidebar-title ai-icon {{(currentHref == item.route) ? 'mm-active' : ''}}"
                    routerLinkActive="active"
                    aria-expanded="false"
                    [class.link-nav]="!item.route"
                    [ngClass]="{ active: item.active }"
                    [attr.title]="sidebarIsCollapsed ? item.title : null"
                  >
                    <i [innerHTML]="item.iconClass" class="sidebar-menu-icon mx-2 {{ item.active ? 'down' : 'right' }}"></i>
                    <span class="sidebar-link__label">
                      <span class="nav-text" *ngIf="!item.isBeta">{{ item.title }}</span>
                      <span class="nav-text nav-text--invoices-v2" *ngIf="item.isBeta">
                        {{ item.title }}<sup class="menu-v2-sup">V2</sup>
                      </span>
                      <span *ngIf="item.isBeta" class="sidebar-beta-badge">{{ 'menu.beta' | translate }}</span>
                    </span>
                  </a>
                </li>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ul>
</div>

  <div class="right-arrow" id="right-arrow" [class.d-none]="rightArrowNone" (click)="scrollToRight()">
    <app-feather-icons [icon]="'arrow-right'"></app-feather-icons>
  </div>
</nav>
